import { DatasPossiveis } from "@/Utils/Formatacao";
import { TypeEmpresa } from "../Pessoa/Empresa";
import { TypeAgencia } from "./Agencia";
import { TypeCentroCusto } from "./CentroCusto";
import Configuracao from "./Conta/Remessa/Configuracao";
import { TypePlanoContas } from "./PlanoContas";
export type TypeConta = {
    codigo?: number,

    codTipoConta?: EnumTipoConta,
    nome?: string,
    numeroConta?: string,
    digitoConta?: string,
    idConciliacao?: string,

    encerrada:boolean,
    dataEncerramento?:DatasPossiveis,

    codRemessaConfiguracao:number | null;
    remessaConfiguracao:Configuracao | null;

    // codPlanoContaTarifa: number | null;
    // planoContaTarifa: TypePlanoContas | null;

    // codCentroCustoTarifa: number | null;
    // centroCustoTarifa: TypeCentroCusto | null;

    codPlanoConta_TaxasGetNet: number | null;
    planoConta_TaxasGetNet: TypePlanoContas | null;

    codPlanoContasTarifaReembolso?: number | undefined;
    planoContasTarifaReembolso?: TypePlanoContas | undefined;
    
    codPlanoConta_TaxasBoleto: number | null;
    planoConta_TaxasBoleto: TypePlanoContas | null;

    codPlanoContasTarifaBoletoReembolso?: number | undefined;
    planoContasTarifaBoletoReembolso?: TypePlanoContas | undefined;

    codEmpresa?: number,
    empresa?: TypeEmpresa,

    codAgencia?: number,
    agencia?: TypeAgencia,

    operador?: number,
    ativo?: boolean,
    dataCriacao?: Date
}

export enum EnumTipoConta {
    CONTACORRENTE = 1,
    INVESTIMENTO = 2,
    CAIXA = 3,
    ADQUIRENTE_CARTEIRA_DIGITAL = 4,
    ADIANTAMENTO_VIAGEM = 5
}

export enum EnumContaProvedorConciliacao
{
    GetNet = 1,
    PagBank = 2
}

export const ContaProvedorConciliacaoDicionario:Record<EnumContaProvedorConciliacao, string> = {
    [EnumContaProvedorConciliacao.GetNet] : "GetNet",
    [EnumContaProvedorConciliacao.PagBank] : "PagBank"
}

export const ContaProvedorConciliacaoLista =[
    {
        value : EnumContaProvedorConciliacao.GetNet,
        label : ContaProvedorConciliacaoDicionario[EnumContaProvedorConciliacao.GetNet]
    },
    {
        value : EnumContaProvedorConciliacao.PagBank,
        label : ContaProvedorConciliacaoDicionario[EnumContaProvedorConciliacao.PagBank]
    }
]


export interface ContaEncerramentoType {
    codConta : number;
    dataEncerramento : Date;
}